import React from 'react';
import { LoginForm, Link } from 'react-admin';

import Login from './Login';

const formSx = {
	'& .ra-input': {
		width: '100%'
	}
};

const sxLink = {
	display: 'block',
	textAlign: 'center',
	textDecoration: 'underline',
	margin: theme => theme.spacing(1)
};

const LoginPage = () => {
	return (
		<Login>
			<LoginForm sx={formSx} />
			<Link to="/forgot-password" sx={sxLink}>Forgot password?</Link>
		</Login>
	);
};

export default LoginPage;
